(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/concat', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/concat'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.concat, global.convert);
    global.concat = mod.exports;
  }
})(this, function (exports, _concat2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.concat = undefined;

  var _concat3 = _interopRequireDefault(_concat2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces an array concatenating the former array with additional arrays and/or values.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {...Array} arrays The arrays to concatenate.
   * @return {Object} Returns the updated object.
   * @example concat({ nested: { prop: [1, 2] } }, 'nested.prop', [3, 4]) // => { nested: { prop: [1, 2, 3, 4] } }
   * @see {@link https://lodash.com/docs#concat|lodash.concat} for more information.
   * @since 0.2.0
   */
  var concat = (0, _convert.convert)(_concat3.default);
  exports.concat = concat;
  exports.default = concat;
});